import React from 'react';
import {
  AGB_CHANGE_PALETTE,
  AGB_CHANGE_BIN_EDGES,
} from '../../lib/agbChangeColors';
import { LegendCard } from './LegendCard';
import { CategoricalLegend } from './CategoricalLegend';

/**
 * Floating legend for the AGB change overlay (smoothed-endpoint diff
 * 2000-04 → 2021-25). Diverging 5-bin palette: red (loss) → gray (stable)
 * → green (gain). Edges are pulled from AGB_CHANGE_BIN_EDGES so the
 * legend can never disagree with the precompute.
 */
export const AgbChangeMapLegend: React.FC = () => {
  const [b0, , , b3] = AGB_CHANGE_BIN_EDGES;
  return (
    <LegendCard title="AGB change · Mg/ha (2000-04 → 2021-25)" positioned className="max-w-[420px]">
      <CategoricalLegend
        palette={AGB_CHANGE_PALETTE}
        rowClassName="flex items-center gap-x-3 gap-y-1 flex-wrap"
      />
      <p className="mt-1.5 text-[10px] font-roboto text-neutral-500 italic">
        Per-pixel difference, {'<'} {b0} = large loss, {'>'} +{b3} = large gain.
      </p>
    </LegendCard>
  );
};
